import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import documents from '../../data/signedIntegrityDocuments.json';

// Curated public copies only. Never imply these modified PDFs retain signatures.
export default function SignedDocumentActions({ slug }) {
  const key = typeof slug === 'string' ? slug.replaceAll('_', '-') : '';
  if (!Object.prototype.hasOwnProperty.call(documents, key)) return null;
  const document = documents[key];

  return (
    <Box component="section" aria-label="Cópia pública do documento institucional"
      sx={{ mt: 4, pt: 2.5, borderTop: '1px solid', borderColor: 'divider', color: 'inherit' }}>
      <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.7 }}>
        {document.relatedDocument ? 'Documento institucional relacionado' : 'Documento institucional - cópia pública'}
      </Typography>
      <Typography variant="body2" sx={{ mb: 1.5, overflowWrap: 'anywhere' }}>
        {document.title}
      </Typography>
      {document.relatedDocument && (
        <Typography variant="caption" component="p" sx={{ mb: 1.5 }}>
          O PDF é um documento institucional relacionado ao tema desta página.
        </Typography>
      )}
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' } }}>
        <Button component="a" variant="contained" size="small"
          href={`/documentos/integridade/${document.file}`} download={document.file}
          startIcon={<DownloadOutlinedIcon />} sx={{ textTransform: 'none', minHeight: 40 }}>
          Baixar cópia pública (PDF)
        </Button>
      </Box>
      <Typography variant="caption" component="p" sx={{ mt: 1.5, lineHeight: 1.6 }}>
        Cópia para consulta com dados pessoais omitidos. O conteúdo normativo foi preservado,
        mas esta via não conserva a assinatura digital do original. O original integral permanece
        no acervo de acesso restrito da R5 e pode ser solicitado para verificação pelo contato
        institucional juridico@r5id.com.br, com o tratamento adequado.
      </Typography>
      <Box component="details" sx={{ mt: 1.5, fontSize: '0.8rem', overflowWrap: 'anywhere' }}>
        <Box component="summary" sx={{ cursor: 'pointer', minHeight: 32, py: 0.5 }}>
          Identificação da cópia pública
        </Box>
        <Typography variant="caption" component="p" sx={{ mt: 0.5 }}>
          SHA-256 da cópia pública: {document.sha256}
        </Typography>
      </Box>
    </Box>
  );
}
